module.exports = __webpack_public_path__ + "kubernetes.icon.c1170.svg";